// Mirrors server/src/models/clinicalGovernance/speakUp/SpeakUpConcern.js —
// keep the two lists in step.
export const SPEAK_UP_CATEGORIES = [
  'Patient safety',
  'Bullying or harassment',
  'Discrimination',
  'Working conditions or wellbeing',
  'Fraud, theft or misconduct',
  'Health and safety',
  'Other',
]

export const SPEAK_UP_STATUSES = ['New', 'Under Review', 'Closed']

export const statusColor = (status) =>
  ({
    New: 'info',
    'Under Review': 'warning',
    Closed: 'success',
  })[status] ?? 'default'
